export type RestClientResource = string | { resource: string; org_id: any; id: any }

export type RestClientHandler = (type: string, resource: RestClientResource, params: any) => Promise<any>

export type RestClientMiddleware = (handler: RestClientHandler) => RestClientHandler

export const composeRestClientMiddleware =
  (...middlewares: RestClientMiddleware[]): RestClientMiddleware =>
  (handler) =>
    middlewares.reduceRight((nextHandler, middleware) => middleware(nextHandler), handler)
